import { PushApi } from 'api';
import { useAuthMutation } from 'queries/query';

function usePostFeedbackNotification() {
  return useAuthMutation(PushApi.postFeedbackNotification);
}

export default usePostFeedbackNotification;
